module.exports = __webpack_public_path__ + "static/media/sms-star-inactive.4e1e1cc9.svg";